export const SET_CURRENCY = 'SET_CURRENCY';

export const SET_CRYPTO = 'SET_CRYPTO';

export const SET_MARKET_DATA = 'SET_MARKET_DATA';